<div id="content">
  <app-password-login *ngIf="usePasswordLogin()" [accountName]="loginHint()!" (tokenAcquired)="loginAsSelf($event)">
  </app-password-login>
</div>

<ng-container *ngIf="usePictureLogin()">
  <app-picture-login [accountName]="loginHint()!" [qrCredentials]="qrCredentials()" [inputPictures]="possiblePictures()" (tokenAcquired)="loginAsSelf($event)"></app-picture-login>
</ng-container>

<ng-container *ngIf="useQrLogin()">
  <app-qr-login (tokenAcquired)="loginAsSelf($event)" (pictureLoginRequired)="showPictureLogin($event)"></app-qr-login>
</ng-container>
